// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"78":"e22afa1c","600":"7a8edd44"}[chunkId] + ".css";
};